import { Gift, CheckCircle2 } from "lucide-react";
import { useT } from "@/lib/i18n";

const fmt = (iso, lang) => new Date(iso).toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" });

export const RewardsHistory = ({ history = [], accent }) => {
  const { t, lang } = useT();
  const items = [...history].reverse();
  return (
    <div data-testid="rewards-history" className="bg-white rounded-2xl border border-[#E6E1DA] p-5">
      <h2 className="font-heading text-base font-bold text-[#1F1D1B] mb-3">{t("rewardsHistory")}</h2>
      {items.length === 0 ? (
        <p data-testid="rewards-history-empty" className="text-sm text-[#6B6560]">{t("noRewards")}</p>
      ) : (
        <ul className="divide-y divide-[#F0EBE3]">
          {items.map((e, i) => (
            <li key={i} data-testid={`rewards-history-item-${i}`} className="flex items-center gap-3 py-2.5">
              <div className="h-8 w-8 rounded-full grid place-items-center shrink-0" style={{ backgroundColor: e.type === "earned" ? `${accent}1A` : "#ECFDF5" }}>
                {e.type === "earned" ? <Gift className="h-4 w-4" style={{ color: accent }} /> : <CheckCircle2 className="h-4 w-4 text-emerald-600" />}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-[#1F1D1B]">{e.type === "earned" ? t("rewardEarned") : t("rewardRedeemed")}</p>
                <p className="text-xs text-[#6B6560] truncate">{e.reward}</p>
              </div>
              <span className="text-xs text-[#6B6560] whitespace-nowrap">{fmt(e.at, lang)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
